// Multilingual content for Madinaty — Arabic (ar), Kurdish (ku), English (en)
import {
  Boxes, Cpu, ShieldCheck, Globe, Smartphone, Bot, Server,
  Hotel, Store, Factory, Stethoscope, GraduationCap, School, Landmark, Building,
  Truck, Fuel
} from "lucide-react";

export const LANGS = [
  { code: "ar", label: "العربية", dir: "rtl" },
  { code: "ku", label: "کوردی", dir: "rtl" },
  { code: "en", label: "English", dir: "ltr" },
];

export const serviceIcons = [Hotel, Boxes, Cpu, ShieldCheck, Globe, Smartphone, Bot, Server];
export const sectorIcons = [Hotel, Store, Factory, Stethoscope, GraduationCap, School, Landmark, Building, Truck, Fuel];

export const content = {
  ar: {
    nav: { about: "من نحن", services: "خدماتنا", why: "لماذا مدينتي", work: "مراحل العمل", projects: "مشاريعنا", blog: "المدونة", cases: "دراسات الحالة", gallery: "معرض أعمالنا", contact: "تواصل معنا" },
    cta: { start: "ابدأ مشروعك", quote: "اطلب عرضًا فنيًا" },
    hero: {
      badge: "شركة عراقية للتحول الرقمي",
      titleLines: ["حلول ذكية", "لمستقبل أفضل"],
      subtitle: "نقدم حلولًا تقنية متكاملة تساعد الشركات والمؤسسات والجهات الحكومية على تسريع التحول الرقمي، وتحسين الأداء، وزيادة الكفاءة، عبر أنظمة ذكية تعتمد أحدث التقنيات العالمية.",
      stats: [
        { n: "9+", l: "حلول متكاملة" },
        { n: "10+", l: "قطاعات نخدمها" },
        { n: "24/7", l: "دعم فني مستمر" },
      ],
    },
    about: {
      tag: "من نحن",
      title: "نبذة عن مدينتي",
      body: "مدينتي لتقنيات المعلومات والحلول الذكية شركة عراقية متخصصة في تطوير البرمجيات، وأنظمة إدارة الأعمال، والحلول الأمنية، والذكاء الاصطناعي، وأنظمة المراقبة والتحكم، وتصميم المواقع والتطبيقات. نعمل على تقديم حلول تقنية مبتكرة تلبي احتياجات الشركات والمؤسسات الحكومية والخاصة، مع الالتزام بأعلى معايير الجودة والأمان والدعم الفني.",
      vision: { title: "رؤيتنا", body: "أن نكون الشركة الرائدة في العراق والمنطقة في تقديم الحلول الرقمية الذكية، والمساهمة في بناء مدن ومؤسسات أكثر تطورًا وكفاءة." },
      mission: { title: "رسالتنا", body: "تقديم حلول تقنية متكاملة تساعد عملاءنا على تطوير أعمالهم، وتحقيق التحول الرقمي، وتحسين الإنتاجية، باستخدام أحدث التقنيات العالمية." },
    },
    intro: {
      tag: "من نحن بالفيديو",
      title: "شاهد كيف نبني المستقبل الرقمي",
      subtitle: "جولة سريعة داخل عالم مدينتي التقني وكيف نحوّل التحديات إلى حلول ذكية.",
      play: "تشغيل الفيديو",
    },
    services: {
      tag: "خدماتنا",
      title: "منظومة خدمات متكاملة",
      subtitle: "من البرمجيات إلى الذكاء الاصطناعي — كل ما تحتاجه مؤسستك تحت سقف واحد.",
      items: [
        { t: "أنظمة إدارة الفنادق", d: "حل متكامل لإدارة الحجوزات، الغرف، الاستقبال، المحاسبة، والمطاعم." },
        { t: "أنظمة إدارة الشركات ERP", d: "إدارة المبيعات، المشتريات، المخازن، الموارد البشرية، المحاسبة، والتقارير." },
        { t: "أنظمة SCADA", d: "حلول مراقبة وتحكم للمصانع، ومحطات المياه، والمجاري، والطاقة." },
        { t: "الكاميرات والأنظمة الأمنية", d: "كاميرات مراقبة، أجهزة بصمة، التحكم بالدخول، وأنظمة الإنذار." },
        { t: "تصميم المواقع الإلكترونية", d: "مواقع احترافية سريعة متوافقة مع جميع الأجهزة مع تحسين محركات البحث." },
        { t: "تطبيقات الهواتف الذكية", d: "تطوير تطبيقات Android و iOS بواجهات عصرية وأداء عالٍ." },
        { t: "حلول الذكاء الاصطناعي", d: "مساعدون افتراضيون، روبوتات محادثة، تحليل بيانات، وأتمتة العمليات." },
        { t: "الاستضافة والسيرفرات", d: "استضافة سحابية، خوادم مخصصة، نسخ احتياطي، وحماية وأمان." },
      ],
    },
    why: {
      tag: "لماذا مدينتي؟",
      title: "أسباب تجعلنا خيارك الأول",
      items: ["فريق متخصص", "حلول متكاملة", "أحدث التقنيات", "دعم فني مستمر", "أسعار تنافسية", "جودة عالية", "تنفيذ احترافي", "تدريب المستخدمين"],
    },
    sectors: { tag: "القطاعات", title: "القطاعات التي نخدمها", items: ["الفنادق والمنتجعات", "الشركات التجارية", "المصانع", "المستشفيات", "الجامعات", "المدارس", "البلديات", "الوزارات", "شركات النقل", "شركات النفط والطاقة"] },
    work: {
      tag: "منهجيتنا",
      title: "مراحل العمل",
      items: [
        { t: "تحليل احتياجات العميل", d: "نفهم أهدافك وتحدياتك بعمق قبل أي خطوة." },
        { t: "إعداد الدراسة الفنية", d: "نصمم خطة تقنية دقيقة وواضحة." },
        { t: "تصميم الحل", d: "بنية معمارية حديثة وواجهات عصرية." },
        { t: "التنفيذ والتركيب", d: "تطوير وتركيب احترافي وفق أعلى المعايير." },
        { t: "الاختبار والتشغيل", d: "اختبارات شاملة لضمان الجودة والاستقرار." },
        { t: "التدريب", d: "تدريب فرقك على استخدام الأنظمة بكفاءة." },
        { t: "الدعم الفني والصيانة", d: "دعم مستمر وصيانة دورية على مدار الساعة." },
      ],
    },
    projects: {
      tag: "أعمالنا",
      title: "مشاريعنا",
      items: ["أنظمة إدارة الفنادق", "أنظمة ERP", "أنظمة SCADA", "مواقع إلكترونية", "تطبيقات الهاتف", "حلول الذكاء الاصطناعي", "الأنظمة الأمنية"],
      viewProject: "استعرض المشروع",
      details: [
        { overview: "منظومة متكاملة لإدارة الحجوزات والغرف والاستقبال والمطاعم والمحاسبة في مكان واحد، مع تقارير لحظية وتجربة ضيف متميزة.", features: ["إدارة الحجوزات والغرف", "استقبال ومحاسبة مركزيّة", "إدارة المطاعم والقاعات", "تقارير مالية وإدارية لحظية", "لوحة تحكم متعددة الفروع", "تكامل مع OTA وبوابات الدفع"] },
        { overview: "نظام ERP شامل يوحّد المبيعات والمشتريات والمخازن والموارد البشرية والمحاسبة، مع رؤية إدارية موحّدة عبر جميع الفروع.", features: ["إدارة المبيعات والمشتريات", "المخازن والمخزون اللحظي", "الموارد البشرية والرواتب", "المحاسبة المالية الكاملة", "تقارير و KPIs تنفيذية", "مزامنة فورية بين الفروع"] },
        { overview: "حلول SCADA لمراقبة وتحكم صناعي متكامل للمصانع ومحطات المياه والطاقة مع تنبيهات فورية وأتمتة موثوقة.", features: ["مراقبة لحظية عبر HMI", "تنبيهات ذكية للأعطال", "أتمتة العمليات الصناعية", "تكامل مع PLC وحساسات IoT", "أرشفة بيانات وتحليلها", "لوحات تحكم مركزية"] },
        { overview: "مواقع إلكترونية احترافية سريعة الأداء ومتوافقة مع محركات البحث وجميع الأجهزة، مصمّمة لتحويل الزوار إلى عملاء.", features: ["تصميم عصري متجاوب", "أداء فائق السرعة", "تحسين محركات البحث SEO", "نظام إدارة محتوى CMS", "تكامل مع تحليلات جوجل", "أمان وحماية متقدّمة"] },
        { overview: "تطبيقات Android و iOS بواجهات عصرية وأداء عالٍ، مع تجربة مستخدم سلسة وتكامل كامل مع أنظمتك.", features: ["تطبيقات Android و iOS", "واجهات مستخدم عصرية", "أداء وتحميل فائق السرعة", "الإشعارات الفورية", "تكامل مع API وأنظمة ERP", "نشر على App Store و Google Play"] },
        { overview: "حلول ذكاء اصطناعي مخصصة تشمل المساعدين الافتراضيين وروبوتات المحادثة وأتمتة العمليات وتحليل البيانات.", features: ["روبوتات محادثة ذكية", "مساعدون افتراضيون", "تحليل بيانات وتنبؤات", "أتمتة العمليات RPA", "معالجة اللغة الطبيعية NLP", "تكامل مع WhatsApp والموقع"] },
        { overview: "حلول أمنية متكاملة تشمل كاميرات المراقبة، وأجهزة البصمة، والتحكم بالدخول، وأنظمة الإنذار لحماية منشأتك.", features: ["كاميرات مراقبة عالية الدقة", "بصمة وتحكّم بالدخول", "أنظمة إنذار متقدمة", "مراقبة عن بُعد", "تسجيل وأرشفة مركزية", "دعم فني على مدار الساعة"] },
      ],
    },
    partners: { tag: "شركاؤنا", title: "شركاء النجاح", body: "نفتخر بثقة عملائنا وشركائنا الذين نفّذنا لهم حلولًا تقنية متكاملة." },
    contact: {
      tag: "تواصل معنا",
      title: "لنبدأ مشروعك القادم",
      subtitle: "أخبرنا عن مشروعك وسيتواصل معك فريقنا لإعداد عرض فني مناسب.",
      fields: { name: "الاسم الكامل", email: "البريد الإلكتروني", phone: "رقم الهاتف", company: "الشركة / الجهة", service: "الخدمة المطلوبة", message: "تفاصيل المشروع" },
      selectService: "اختر الخدمة",
      submit: "إرسال الطلب",
      sending: "جارٍ الإرسال...",
      success: "تم استلام طلبك بنجاح! سنتواصل معك قريبًا.",
      error: "حدث خطأ، حاول مرة أخرى.",
      info: { phone: "الهاتف", email: "البريد", location: "الموقع", locationVal: "بغداد - الكرادة" },
    },
    achievements: { tag: "إنجازاتنا", title: "أرقام تتحدّث عنّا" },
    timeline: { tag: "رحلتنا", title: "خط زمن الإنجازات", subtitle: "من التأسيس حتى اليوم — محطّات مدينتي." },
    map: {
      tag: "موقعنا",
      title: "زُرنا في مكاتبنا",
      subtitle: "نرحّب بزيارتك لمناقشة مشروعك القادم وجهًا لوجه مع فريقنا التقني.",
      cardTitle: "معلومات المكتب",
      addressLabel: "العنوان",
      hoursLabel: "ساعات العمل",
      directions: "احصل على الاتجاهات",
      openMaps: "افتح في خرائط جوجل",
      defaultAddress: "العراق - بغداد - الكرادة - العرضات الهندية قرب مصرف التنمية",
      defaultHours: "السبت – الخميس: 8:00 صباحًا – 5:00 مساءً | الجمعة: مغلق",
    },
    testimonials: { tag: "آراء العملاء", title: "ماذا يقول عملاؤنا", subtitle: "ثقة عملائنا هي أكبر إنجازاتنا." },
    faq: { tag: "الأسئلة الشائعة", title: "إجابات لأكثر أسئلتكم شيوعًا", subtitle: "كل ما تريد معرفته عن خدماتنا وطريقة عملنا." },
    whatsapp: "تواصل عبر واتساب",
    careers: { tag: "الوظائف", title: "انضم إلى فريق مدينتي", subtitle: "نبحث دائمًا عن المواهب المتميزة لبناء المستقبل الرقمي.", type: "نوع الدوام", location: "الموقع", requirements: "المتطلبات", apply: "قدّم عبر واتساب", empty: "لا توجد وظائف شاغرة حاليًا." },
    newsletter: { title: "اشترك في نشرتنا البريدية", subtitle: "أحدث الأخبار والعروض التقنية في بريدك.", placeholder: "بريدك الإلكتروني", button: "اشترك", success: "تم الاشتراك بنجاح!", error: "تعذّر الاشتراك." },
    cookie: { text: "نستخدم ملفات تعريف الارتباط لتحسين تجربتك على الموقع.", accept: "موافق", more: "المزيد" },
    chatHuman: "تحدث مع موظف",
    profile: "الملف التعريفي",
    serviceDetail: { overview: "نظرة عامة", cta: "اطلب هذه الخدمة", back: "كل الخدمات", features: "أبرز المزايا" },
    projectDetail: { back: "كل المشاريع", overview: "نظرة عامة", features: "أبرز المزايا", watchIntro: "شاهد الفيديو التعريفي", cta: "اطلب هذا النظام", videoUnavailable: "الفيديو غير متوفر حاليًا", screenshots: "معرض الشاشات", screenshotsTitle: "لمحة من داخل النظام" },
    share: { title: "شارك", copy: "نسخ الرابط", copied: "تم النسخ ✓" },
    filters: { all: "الكل", searchBlog: "ابحث في المقالات...", searchCases: "ابحث في دراسات الحالة...", noResults: "لا توجد نتائج مطابقة لبحثك." },
    quote: {
      tag: "حاسبة العرض",
      title: "احسب تكلفة مشروعك في ثوانٍ",
      subtitle: "اختر نوع النظام وحجم فريقك والوحدات — ستحصل على نطاق سعري تقديري ومدة تسليم فورًا.",
      types: { hotel: "أنظمة الفنادق", erp: "أنظمة ERP", scada: "SCADA", website: "موقع إلكتروني", mobile: "تطبيق موبايل", ai: "حلول AI", security: "أنظمة أمنية" },
      chooseType: "اختر نوع النظام",
      users: "عدد المستخدمين",
      modules: "عدد الوحدات",
      estimate: "التقدير المبدئي",
      type: "النوع",
      delivery: "مدة التسليم",
      weeks: "أسبوعًا",
      usd: "دولار أمريكي — نطاق تقديري",
      disclaimer: "* هذا تقدير تقريبي، السعر النهائي يعتمد على المتطلبات الفعلية وسنتواصل معك بعرض مفصّل خلال 24 ساعة.",
      getPersonalized: "احصل على عرض مخصّص فوري",
      sendCta: "أرسل الطلب",
      sending: "جارٍ الإرسال...",
      sentBadge: "تم الإرسال ✓",
      success: "تم استلام طلبك، سنتواصل معك خلال 24 ساعة!",
      error: "تعذّر الإرسال، حاول مرة أخرى",
      errPhone: "أدخل رقم هاتف صحيح",
      rateLimited: "لقد أرسلت طلبات كثيرة. حاول لاحقًا.",
      anonName: "زائر (حاسبة العرض)",
      leadTemplate: "طلب من حاسبة العرض:\n\n- نوع النظام: {type}\n- عدد المستخدمين: {users}\n- عدد الوحدات: {modules}\n- التقدير: ${low} – ${high}\n- التسليم: {w1}–{w2} أسبوعًا",
    },
    booking: {
      tag: "حجز استشارة",
      title: "احجز مكالمتك المجانية",
      subtitle: "مدتها 30 دقيقة، مع مستشار تقني — بدون التزام.",
      pickDate: "اختر التاريخ",
      pickTime: "اختر الوقت المناسب",
      closedDay: "هذا اليوم مغلق (الجمعة عطلة).",
      topicPh: "موضوع الاستشارة (اختياري)",
      notesPh: "أي تفاصيل تودّ إخبارنا بها قبل المكالمة (اختياري)",
      submit: "أكّد الحجز",
      sending: "جارٍ الحجز...",
      success: "تم الحجز! ستصلك رسالة تأكيد بريدية.",
      errPickSlot: "اختر تاريخًا ووقتًا أولًا",
      errFields: "أدخل الاسم ورقمًا صحيحًا (7 خانات على الأقل)",
      errTaken: "هذا الوقت محجوز مسبقًا، اختر وقتًا آخر",
      errRate: "لقد أرسلت طلبات كثيرة. حاول لاحقًا.",
      errGeneric: "تعذّر الحجز، حاول مرة أخرى",
      confirmedTitle: "تم تأكيد حجزك",
      confirmedSub: "سنتصل بك في الموعد المحدد على الرقم الذي أدخلته.",
    },
    sectorExplorer: {
      tag: "استكشف بحسب قطاعك",
      title: "أفضل الحلول لقطاعك",
      subtitle: "اختر قطاعك وشاهد الأنظمة والحالات الأنسب لأعمالك.",
      relatedCases: "حالات ذات صلة",
      viewAll: "جميع الحالات",
    },
    support: {
      tag: "الدعم الفني",
      title: "افتح تذكرة دعم",
      subtitle: "للعملاء الحاليين — سنردّ عليك خلال ساعات العمل.",
      subjectPh: "موضوع التذكرة (مثلاً: مشكلة في تسجيل الدخول)",
      messagePh: "اشرح مشكلتك بالتفصيل...",
      submit: "أرسل التذكرة",
      sending: "جارٍ الإرسال...",
      success: "تم فتح تذكرتك، سنتواصل معك قريبًا",
      sentTitle: "تم استلام تذكرتك ✅",
      sentSub: "سيقوم فريق الدعم بالردّ على بريدك خلال ساعات العمل.",
      errFields: "يرجى تعبئة كل الحقول المطلوبة",
      errRate: "لقد أرسلت طلبات كثيرة. حاول لاحقًا.",
      errGeneric: "تعذّر إرسال التذكرة، حاول مرة أخرى",
      priorities: { low: "منخفض", normal: "عادي", high: "مرتفع", urgent: "عاجل" },
    },
    stickyBar: {
      title: "نتّصل بك خلال 10 دقائق",
      subtitle: "اكتب رقمك ونتصل بك فورًا",
      placeholder: "07XX XXXXXXX",
      cta: "اتصل بي",
      success: "تم! سنتصل بك قريبًا ✓",
      error: "تعذّر الإرسال، حاول مرة أخرى",
      rateLimited: "لقد أرسلت طلبات كثيرة. حاول لاحقًا.",
      invalid: "أدخل رقم هاتف صحيح",
      leadName: "طلب معاودة اتصال (شريط عائم)",
      leadMessage: "الرجاء الاتصال بي في أقرب وقت ممكن.",
    },
    legal: { privacy: "سياسة الخصوصية", terms: "شروط الاستخدام", backHome: "العودة للرئيسية", updated: "آخر تحديث" },
    footer: { slogan: "مدينتي... حلول ذكية لمستقبل أفضل", rights: "جميع الحقوق محفوظة", built: "مدينتي لتقنيات المعلومات والحلول الذكية" },
    team: { tag: "فريق العمل", title: "القيادة خلف مدينتي", subtitle: "نخبة من الخبراء يقودون رحلتك نحو التحول الرقمي." },
    blog: { tag: "المدونة", title: "أحدث المقالات والأخبار", subtitle: "رؤى ومقالات تقنية من فريق مدينتي.", readMore: "اقرأ المزيد", back: "العودة إلى المدونة", empty: "لا توجد مقالات بعد.", by: "بقلم" },
    cases: { tag: "دراسات الحالة", title: "قصص نجاح عملائنا", subtitle: "مشكلة، حل، ونتيجة — هكذا نصنع الأثر.", problem: "التحدي", solution: "الحل", result: "النتيجة", back: "العودة إلى دراسات الحالة", empty: "لا توجد دراسات حالة بعد.", client: "العميل", sector: "القطاع", viewCase: "عرض الدراسة" },
    chat: { title: "المساعد الذكي", welcome: "مرحبًا! أنا المساعد الذكي لمدينتي. كيف أساعدك اليوم؟", placeholder: "اكتب سؤالك...", open: "تحدث معنا", handoffPreface: "مرحبًا فريق مدينتي، تحدّثت مع المساعد الذكي وأودّ الحديث مع موظف بخصوص:" },
  },

  ku: {
    nav: { about: "دەربارەی ئێمە", services: "خزمەتگوزارییەکان", why: "بۆچی مەدینەتی", work: "قۆناغەکانی کار", projects: "پڕۆژەکانمان", blog: "بلۆگ", cases: "لێکۆڵینەوەکان", gallery: "کاری ئێمە", contact: "پەیوەندی" },
    cta: { start: "پڕۆژەکەت دەست پێبکە", quote: "داواکاری پێشکەشکراوی تەکنیکی" },
    hero: {
      badge: "کۆمپانیایەکی عێراقی بۆ گۆڕانی دیجیتاڵ",
      titleLines: ["چارەسەری زیرەک", "بۆ داهاتوویەکی باشتر"],
      subtitle: "چارەسەری تەکنەلۆژی یەکگرتوو پێشکەش دەکەین کە یارمەتی کۆمپانیا و دامەزراوە حکومییەکان دەدات بۆ خێراکردنی گۆڕانی دیجیتاڵ، باشترکردنی کارایی و زیادکردنی بەرهەمهێنان، بە سیستەمی زیرەک لەسەر نوێترین تەکنەلۆژیای جیهانی.",
      stats: [
        { n: "9+", l: "چارەسەری یەکگرتوو" },
        { n: "10+", l: "کەرتی خزمەتکراو" },
        { n: "24/7", l: "پشتگیری بەردەوام" },
      ],
    },
    about: {
      tag: "دەربارەی ئێمە",
      title: "دەربارەی مەدینەتی",
      body: "مەدینەتی بۆ تەکنەلۆژیای زانیاری و چارەسەرە زیرەکەکان کۆمپانیایەکی عێراقییە پسپۆڕە لە گەشەپێدانی نەرمەکاڵا، سیستەمی بەڕێوەبردنی کار، چارەسەری ئاسایشی، زیرەکی دەستکرد، سیستەمی چاودێری و کۆنترۆڵ، و دیزاینی ماڵپەڕ و ئەپەکان. کار دەکەین بۆ پێشکەشکردنی چارەسەری داهێنەرانە کە پێداویستی کۆمپانیا و دامەزراوە حکومی و تایبەتەکان دابین دەکات، لەگەڵ پابەندبوون بە بەرزترین ستانداردی جۆرایەتی و ئاسایش و پشتگیری تەکنیکی.",
      vision: { title: "دیدگامان", body: "ببینە پێشەنگترین کۆمپانیا لە عێراق و ناوچەکە لە پێشکەشکردنی چارەسەری دیجیتاڵی زیرەک، و بەشداری لە بنیاتنانی شار و دامەزراوەی پێشکەوتووتر." },
      mission: { title: "ئەرکمان", body: "پێشکەشکردنی چارەسەری تەکنەلۆژی یەکگرتوو کە یارمەتی کڕیارەکانمان دەدات بۆ گەشەپێدانی کارەکانیان و بەدەستهێنانی گۆڕانی دیجیتاڵ، بە نوێترین تەکنەلۆژیای جیهانی." },
    },
    intro: {
      tag: "ئێمە بە ڤیدیۆ",
      title: "ببینە چۆن داهاتووی دیجیتاڵ بنیات دەنێین",
      subtitle: "گەشتێکی خێرا بۆ ناو جیهانی تەکنیکی مەدینەتی و چۆن ئاستەنگەکان دەکەینە چارەسەری زیرەک.",
      play: "لێدانی ڤیدیۆ",
    },
    services: {
      tag: "خزمەتگوزارییەکان",
      title: "سیستەمی خزمەتگوزاری یەکگرتوو",
      subtitle: "لە نەرمەکاڵاوە تا زیرەکی دەستکرد — هەرچی دامەزراوەکەت پێویستی پێیەتی لە ژێر یەک سەقفدا.",
      items: [
        { t: "سیستەمی بەڕێوەبردنی هۆتێل", d: "چارەسەری یەکگرتوو بۆ حیجز، ژوور، پێشوازی، ژمێریاری و چێشتخانە." },
        { t: "سیستەمی بەڕێوەبردنی کۆمپانیا ERP", d: "بەڕێوەبردنی فرۆشتن، کڕین، کۆگا، سەرچاوەی مرۆیی، ژمێریاری و ڕاپۆرت." },
        { t: "سیستەمی SCADA", d: "چارەسەری چاودێری و کۆنترۆڵ بۆ کارگە، ئاو، ئاوەڕۆ و وزە." },
        { t: "کامێرا و سیستەمە ئاسایشییەکان", d: "کامێرای چاودێری، پەنجەمۆر، کۆنترۆڵی چوونەژوورەوە و سیستەمی ئاگادارکردنەوە." },
        { t: "دیزاینی ماڵپەڕ", d: "ماڵپەڕی پیشەیی و خێرا کە لەگەڵ هەموو ئامێرەکان دەگونجێت لەگەڵ باشترکردنی SEO." },
        { t: "ئەپی مۆبایل", d: "گەشەپێدانی ئەپی Android و iOS بە ڕووکاری سەردەمیانە و کارایی بەرز." },
        { t: "چارەسەری زیرەکی دەستکرد", d: "یاریدەدەری مەجازی، بۆتی گفتوگۆ، شیکردنەوەی داتا و ئۆتۆماتیکردنی پرۆسەکان." },
        { t: "هۆستینگ و سێرڤەر", d: "هۆستینگی هەوری، سێرڤەری تایبەت، پاشەکەوتکردن و پاراستن." },
      ],
    },
    why: {
      tag: "بۆچی مەدینەتی؟",
      title: "هۆکارەکان کە دەتانکەن یەکەم هەڵبژاردەت",
      items: ["تیمی پسپۆڕ", "چارەسەری یەکگرتوو", "نوێترین تەکنەلۆژیا", "پشتگیری بەردەوام", "نرخی گونجاو", "جۆرایەتی بەرز", "جێبەجێکردنی پیشەیی", "ڕاهێنانی بەکارهێنەران"],
    },
    sectors: { tag: "کەرتەکان", title: "ئەو کەرتانەی خزمەتیان دەکەین", items: ["هۆتێل و پێشوازیگا", "کۆمپانیا بازرگانییەکان", "کارگەکان", "نەخۆشخانەکان", "زانکۆکان", "قوتابخانەکان", "شارەوانییەکان", "وەزارەتەکان", "کۆمپانیای گواستنەوە", "کۆمپانیای نەوت و وزە"] },
    work: {
      tag: "میتۆدمان",
      title: "قۆناغەکانی کار",
      items: [
        { t: "شیکردنەوەی پێداویستی کڕیار", d: "پێش هەر هەنگاوێک ئامانج و ئاستەنگەکانت بە قووڵی تێدەگەین." },
        { t: "ئامادەکردنی توێژینەوەی تەکنیکی", d: "پلانێکی تەکنیکی ورد و ڕوون دیزاین دەکەین." },
        { t: "دیزاینی چارەسەر", d: "بنیاتی سەردەمیانە و ڕووکاری نوێ." },
        { t: "جێبەجێکردن و دامەزراندن", d: "گەشەپێدان و دامەزراندنی پیشەیی بەپێی بەرزترین ستاندارد." },
        { t: "تاقیکردنەوە و کارپێکردن", d: "تاقیکردنەوەی تەواو بۆ دڵنیایی لە جۆرایەتی و جێگیری." },
        { t: "ڕاهێنان", d: "ڕاهێنانی تیمەکانت بۆ بەکارهێنانی سیستەمەکان بە کارایی." },
        { t: "پشتگیری تەکنیکی و چاکسازی", d: "پشتگیری بەردەوام و چاکسازی دەورەیی بە درێژایی کات." },
      ],
    },
    projects: {
      tag: "کارەکانمان",
      title: "پڕۆژەکانمان",
      items: ["سیستەمی هۆتێل", "سیستەمی ERP", "سیستەمی SCADA", "ماڵپەڕەکان", "ئەپی مۆبایل", "چارەسەری AI", "سیستەمە ئاسایشییەکان"],
      viewProject: "پڕۆژە ببینە",
      details: [
        { overview: "سیستەمێکی یەکگرتوو بۆ بەڕێوەبردنی حیجز، ژوور، پێشوازی، چێشتخانە و ژمێریاری لە یەک شوێن، لەگەڵ ڕاپۆرتی ڕاستەوخۆ.", features: ["بەڕێوەبردنی حیجز و ژوور", "پێشوازی و ژمێریاری ناوەندی", "بەڕێوەبردنی چێشتخانە", "ڕاپۆرتی دارایی ڕاستەوخۆ", "پانێڵی چەند لق", "هاوکاری لەگەڵ OTA"] },
        { overview: "سیستەمی ERP یەکخستنی فرۆشتن و کڕین و کۆگا و سەرچاوەی مرۆیی و ژمێریاری لەگەڵ دیدێکی یەکگرتوو بۆ بەڕێوەبردن.", features: ["بەڕێوەبردنی فرۆشتن و کڕین", "کۆگا و ئینڤێنتۆری", "سەرچاوەی مرۆیی و مووچە", "ژمێریاری تەواو", "ڕاپۆرت و KPI", "مزامنە لەنێوان لقەکان"] },
        { overview: "چارەسەری SCADA بۆ چاودێری و کۆنترۆڵی پیشەسازی کارگە و ئاو و وزە لەگەڵ ئاگاداری خێرا و ئۆتۆماسیۆنی متمانەپێکراو.", features: ["چاودێری ڕاستەوخۆ لە HMI", "ئاگاداری زیرەکی کێشە", "ئۆتۆماسیۆنی پرۆسە", "هاوکاری لەگەڵ PLC و IoT", "ئارشیفی داتا", "پانێڵی ناوەندی"] },
        { overview: "ماڵپەڕی پیشەیی خێرا و لەگەڵ SEO و هەموو ئامێرەکان دەگونجێت، دیزاینکراوە بۆ گۆڕینی سەردانکەر بۆ کڕیار.", features: ["دیزاینی سەردەمیانە", "خێرایی زۆر", "باشترکردنی SEO", "سیستەمی CMS", "هاوکاری لەگەڵ Google Analytics", "ئاسایشی بەرز"] },
        { overview: "ئەپی Android و iOS بە ڕووکاری سەردەمیانە و کارایی بەرز، لەگەڵ ئەزموونی بەکارهێنەری هەموار و هاوکاری تەواو.", features: ["ئەپی Android و iOS", "ڕووکاری سەردەمیانە", "کارایی خێرا", "ئاگاداری خێرا", "هاوکاری لەگەڵ API", "بڵاوکردنەوە لە ستۆر"] },
        { overview: "چارەسەری AI تایبەت لەوانە یاریدەدەری مەجازی، بۆتی گفتوگۆ، ئۆتۆماسیۆنی پرۆسە و شیکردنەوەی داتا.", features: ["بۆتی گفتوگۆی زیرەک", "یاریدەدەری مەجازی", "شیکردنەوە و پێشبینی", "ئۆتۆماسیۆنی RPA", "پرۆسەکردنی زمانی سروشتی", "هاوکاری لەگەڵ WhatsApp"] },
        { overview: "چارەسەری ئاسایشی یەکگرتوو کە کامێرا و پەنجەمۆر و کۆنترۆڵی چوونەژوورەوە و ئاگادارکردنەوە لەخۆدەگرێت.", features: ["کامێرای HD", "پەنجەمۆر و کۆنترۆڵی چوونەژوورەوە", "سیستەمی ئاگادارکردنەوە", "چاودێری لە دوورەوە", "تۆمارکردنی ناوەندی", "پشتگیری 24/7"] },
      ],
    },
    partners: { tag: "هاوبەشەکانمان", title: "هاوبەشانی سەرکەوتن", body: "شانازی بە متمانەی کڕیار و هاوبەشەکانمان دەکەین کە چارەسەری یەکگرتوومان بۆ جێبەجێ کردوون." },
    contact: {
      tag: "پەیوەندی",
      title: "با پڕۆژەکەت دەست پێبکەین",
      subtitle: "دەربارەی پڕۆژەکەت پێمان بڵێ و تیمەکەمان پەیوەندیت پێوە دەکات بۆ ئامادەکردنی پێشکەشکراوی گونجاو.",
      fields: { name: "ناوی تەواو", email: "ئیمەیڵ", phone: "ژمارەی تەلەفۆن", company: "کۆمپانیا / لایەن", service: "خزمەتگوزاری پێویست", message: "وردەکاری پڕۆژە" },
      selectService: "خزمەتگوزاری هەڵبژێرە",
      submit: "ناردنی داواکاری",
      sending: "دەنێردرێت...",
      success: "داواکارییەکەت وەرگیرا! بەم زووانە پەیوەندیت پێوە دەکەین.",
      error: "هەڵەیەک ڕوویدا، دووبارە هەوڵبدەرەوە.",
      info: { phone: "تەلەفۆن", email: "ئیمەیڵ", location: "شوێن", locationVal: "بەغدا - کەڕادە" },
    },
    achievements: { tag: "دەستکەوتەکانمان", title: "ژمارەکان لەبارەی ئێمەوە دەدوێن" },
    timeline: { tag: "گەشتەکەمان", title: "هێڵی کاتی دەستکەوتەکان", subtitle: "لە دامەزراندنەوە بۆ ئەمڕۆ — مێژووی مەدینەتی." },
    map: {
      tag: "شوێنمان",
      title: "سەردانمان بکە لە نووسینگەکانمان",
      subtitle: "بەخێرهاتنی سەردانتانین بۆ گفتوگۆکردن دەربارەی پڕۆژەکەت ڕوو بە ڕوو لەگەڵ تیمە تەکنیکییەکەمان.",
      cardTitle: "زانیاری نووسینگە",
      addressLabel: "ناونیشان",
      hoursLabel: "کاتەکانی کارکردن",
      directions: "ئاراستەکان بەدەست بهێنە",
      openMaps: "کردنەوە لە Google Maps",
      defaultAddress: "عێراق - بەغدا - کەڕادە - عەرەداتی هیندی، نزیک بانکی گەشەپێدان",
      defaultHours: "شەممە – پێنجشەممە: 8:00 بەیانی – 5:00 ئێوارە | هەینی: داخراوە",
    },
    testimonials: { tag: "بۆچوونی کڕیارەکان", title: "کڕیارەکانمان چی دەڵێن", subtitle: "متمانەی کڕیارەکانمان گەورەترین دەستکەوتمانە." },
    faq: { tag: "پرسیارە باوەکان", title: "وەڵامی باوترین پرسیارەکانتان", subtitle: "هەرچی دەتەوێت لەبارەی خزمەتگوزارییەکانمانەوە بیزانیت." },
    whatsapp: "پەیوەندی بە واتساپ",
    careers: { tag: "هەلی کار", title: "بەشداری تیمی مەدینەتی بکە", subtitle: "هەمیشە بەدوای بەهرەی نایابدا دەگەڕێین.", type: "جۆری کار", location: "شوێن", requirements: "پێداویستییەکان", apply: "داواکاری بە واتساپ", empty: "لە ئێستادا هیچ هەلێکی کار نییە." },
    newsletter: { title: "بەشداربە لە هەواڵنامەکەمان", subtitle: "نوێترین هەواڵ و پێشکەشکراوی تەکنیکی.", placeholder: "ئیمەیڵەکەت", button: "بەشداربە", success: "بەسەرکەوتوویی بەشداربوویت!", error: "بەشداربوون سەرکەوتوو نەبوو." },
    cookie: { text: "کووکی بەکاردەهێنین بۆ باشترکردنی ئەزموونت.", accept: "ڕازیم", more: "زیاتر" },
    chatHuman: "قسە لەگەڵ کارمەند بکە",
    profile: "پرۆفایلی کۆمپانیا",
    serviceDetail: { overview: "تێڕوانینی گشتی", cta: "داواکاری ئەم خزمەتگوزارییە", back: "هەموو خزمەتگوزارییەکان", features: "تایبەتمەندییە سەرەکییەکان" },
    projectDetail: { back: "هەموو پڕۆژەکان", overview: "تێڕوانینی گشتی", features: "تایبەتمەندییە سەرەکییەکان", watchIntro: "ڤیدیۆی ناساندن ببینە", cta: "داواکاری ئەم سیستەمە", videoUnavailable: "ڤیدیۆ لە ئێستادا بەردەست نییە", screenshots: "پیشاندانەکان", screenshotsTitle: "لەناوی سیستەمەکەوە" },
    share: { title: "هاوبەشی بکە", copy: "کۆپیکردنی بەستەر", copied: "کۆپی کرا ✓" },
    filters: { all: "هەموو", searchBlog: "گەڕان لە بابەتەکان...", searchCases: "گەڕان لە کەیسەکان...", noResults: "هیچ ئەنجامێک نەدۆزرایەوە." },
    quote: {
      tag: "ژمێرەری نرخ",
      title: "نرخی پڕۆژەکەت لە چەند چرکەیەکدا هەژمار بکە",
      subtitle: "جۆری سیستەم، قەبارەی تیم، و ماژوڵەکان هەڵبژێرە — پێشبینی نرخ و کاتی گەیاندن دەبینیت.",
      types: { hotel: "سیستەمی هۆتێل", erp: "سیستەمی ERP", scada: "SCADA", website: "ماڵپەڕ", mobile: "ئەپی مۆبایل", ai: "چارەسەری AI", security: "سیستەمی ئاسایش" },
      chooseType: "جۆری سیستەم هەڵبژێرە",
      users: "ژمارەی بەکارهێنەران",
      modules: "ژمارەی ماژوڵەکان",
      estimate: "خەملاندنی سەرەتایی",
      type: "جۆر",
      delivery: "کاتی گەیاندن",
      weeks: "هەفتە",
      usd: "دۆلار — پێشبینی",
      disclaimer: "* ئەمە خەملاندنێکی سەرەتاییە، نرخی کۆتایی بەپێی داواکاری ڕاستەقینەکە دیاری دەکرێت.",
      getPersonalized: "پێشکەشکراوی تایبەتی وەربگرە",
      sendCta: "بنێرە",
      sending: "دەنێردرێت...",
      sentBadge: "نێردرا ✓",
      success: "داواکارییەکەت وەرگیرا، پەیوەندیت پێوە دەکەین!",
      error: "نەتوانرا بنێردرێت",
      errPhone: "ژمارەیەکی دروست بنووسە",
      rateLimited: "زۆر داواکاری. دواتر هەوڵ بدە.",
      anonName: "سەردانکەر (ژمێرەری نرخ)",
      leadTemplate: "داواکاری لە ژمێرەری نرخ:\n\n- جۆری سیستەم: {type}\n- بەکارهێنەران: {users}\n- ماژوڵ: {modules}\n- خەملاندن: ${low} – ${high}\n- گەیاندن: {w1}–{w2} هەفتە",
    },
    booking: {
      tag: "حیجزکردنی ڕاوێژ",
      title: "حیجزی پەیوەندی بەخۆڕایی بکە",
      subtitle: "30 خولەک لەگەڵ ڕاوێژکارێکی تەکنیکی — بێ ئەرک.",
      pickDate: "بەروار هەڵبژێرە",
      pickTime: "کاتی گونجاو هەڵبژێرە",
      closedDay: "ئەم ڕۆژە داخراوە (هەینی پشوو).",
      topicPh: "بابەتی ڕاوێژ (ئارەزوومەندانە)",
      notesPh: "هەر تێبینییەک پێش پەیوەندی (ئارەزوومەندانە)",
      submit: "حیجزەکە پشتڕاست بکەرەوە",
      sending: "دەحیجزرێت...",
      success: "حیجزت تۆمار کرا!",
      errPickSlot: "پێش هەموو شتێک بەروار و کات هەڵبژێرە",
      errFields: "ناو و ژمارەیەکی دروست بنووسە",
      errTaken: "ئەم کاتە حیجزکراوە، کاتێکی تر هەڵبژێرە",
      errRate: "زۆر داواکاری. دواتر هەوڵ بدە.",
      errGeneric: "نەتوانرا حیجز بکرێت",
      confirmedTitle: "حیجزەکەت پشتڕاست کرایەوە",
      confirmedSub: "لە کاتی دیاریکراودا پەیوەندیت پێوە دەکەین.",
    },
    sectorExplorer: {
      tag: "بەپێی کەرتەکەت بگەڕێ",
      title: "باشترین چارەسەر بۆ کەرتەکەت",
      subtitle: "کەرتەکەت هەڵبژێرە و باشترین سیستەم و کەیس ببینە.",
      relatedCases: "کەیسی پەیوەندیدار",
      viewAll: "هەموو کەیسەکان",
    },
    support: {
      tag: "پشتگیری تەکنیکی",
      title: "تیکەتێکی پشتگیری بکەرەوە",
      subtitle: "بۆ کڕیارە هەبووەکان — لە کاتی کارکردندا وەڵامت دەدەینەوە.",
      subjectPh: "بابەتی تیکەت",
      messagePh: "کێشەکەت بە وردی ڕوون بکەرەوە...",
      submit: "تیکەت بنێرە",
      sending: "دەنێردرێت...",
      success: "تیکەتەکەت وەرگیرا",
      sentTitle: "تیکەتەکەت تۆمار کرا ✅",
      sentSub: "تیمی پشتگیری وەڵامت دەداتەوە.",
      errFields: "تکایە هەموو خانە پێویستەکان پڕ بکەرەوە",
      errRate: "زۆر داواکاری. دواتر هەوڵ بدە.",
      errGeneric: "نەتوانرا بنێردرێت",
      priorities: { low: "نزم", normal: "ئاسایی", high: "بەرز", urgent: "خێرا" },
    },
    stickyBar: {
      title: "لە 10 خولەکدا پەیوەندیت پێوە دەکەین",
      subtitle: "ژمارەکەت بنووسە و پەیوەندیت پێوە دەکەین",
      placeholder: "07XX XXXXXXX",
      cta: "پەیوەندیم پێوە بکە",
      success: "تەواو! زوو پەیوەندیت پێوە دەکەین ✓",
      error: "نەتوانرا بنێردرێت، دووبارە هەوڵ بدە",
      rateLimited: "زۆر داواکاری نێردراوە. دواتر هەوڵ بدە.",
      invalid: "ژمارەیەکی دروست بنووسە",
      leadName: "داواکاری پەیوەندی (بارە داسەپیو)",
      leadMessage: "تکایە زوو پەیوەندیم پێوە بکە.",
    },
    legal: { privacy: "سیاسەتی تایبەتمەندی", terms: "مەرجەکانی بەکارهێنان", backHome: "گەڕانەوە بۆ ماڵەوە", updated: "دوایین نوێکردنەوە" },
    footer: { slogan: "مەدینەتی... چارەسەری زیرەک بۆ داهاتوویەکی باشتر", rights: "هەموو مافەکان پارێزراون", built: "مەدینەتی بۆ تەکنەلۆژیای زانیاری و چارەسەرە زیرەکەکان" },
    team: { tag: "تیمی کار", title: "سەرکردایەتی پشت مەدینەتی", subtitle: "کۆمەڵێک پسپۆڕ گەشتەکەت بەرەو گۆڕانی دیجیتاڵ ڕابەرایەتی دەکەن." },
    blog: { tag: "بلۆگ", title: "نوێترین بابەت و هەواڵەکان", subtitle: "تێڕوانین و بابەتی تەکنیکی لە تیمی مەدینەتی.", readMore: "زیاتر بخوێنەرەوە", back: "گەڕانەوە بۆ بلۆگ", empty: "هێشتا بابەت نییە.", by: "لەلایەن" },
    cases: { tag: "لێکۆڵینەوەکان", title: "چیرۆکی سەرکەوتنی کڕیارەکانمان", problem: "ئاستەنگ", solution: "چارەسەر", result: "ئەنجام", subtitle: "کێشە، چارەسەر و ئەنجام — بەم شێوەیە کاریگەری دروست دەکەین.", back: "گەڕانەوە بۆ لێکۆڵینەوەکان", empty: "هێشتا لێکۆڵینەوە نییە.", client: "کڕیار", sector: "کەرت", viewCase: "بینینی لێکۆڵینەوە" },
    chat: { title: "یاریدەدەری زیرەک", welcome: "بەخێربێیت! من یاریدەدەری زیرەکی مەدینەتیم. چۆن یارمەتیت بدەم؟", placeholder: "پرسیارەکەت بنووسە...", open: "قسەمان لەگەڵ بکە", handoffPreface: "سڵاو، لەگەڵ یاریدەدەری زیرەک قسەم کرد و دەمەوێت لەگەڵ کارمەند قسە بکەم دەربارەی:" },
  },

  en: {
    nav: { about: "About", services: "Services", why: "Why Us", work: "Process", projects: "Projects", blog: "Blog", cases: "Case Studies", gallery: "Gallery", contact: "Contact" },
    cta: { start: "Start Your Project", quote: "Request a Quote" },
    hero: {
      badge: "Iraqi digital transformation company",
      titleLines: ["Smart Solutions", "For a Better Future"],
      subtitle: "We deliver integrated technology solutions that help companies, institutions and government entities accelerate digital transformation, improve performance and boost efficiency through smart systems built on the latest global technologies.",
      stats: [
        { n: "9+", l: "Integrated solutions" },
        { n: "10+", l: "Sectors served" },
        { n: "24/7", l: "Continuous support" },
      ],
    },
    about: {
      tag: "About Us",
      title: "About Madinaty",
      body: "Madinaty for Information Technology and Smart Solutions is an Iraqi company specialized in software development, business management systems, security solutions, artificial intelligence, monitoring & control systems, and web & app design. We provide innovative technology solutions that meet the needs of private and government institutions, committed to the highest standards of quality, security and technical support.",
      vision: { title: "Our Vision", body: "To be the leading company in Iraq and the region in delivering smart digital solutions, contributing to building more advanced and efficient cities and institutions." },
      mission: { title: "Our Mission", body: "To deliver integrated technology solutions that help our clients grow their business, achieve digital transformation and improve productivity using the latest global technologies." },
    },
    intro: {
      tag: "Watch Our Story",
      title: "See How We Build the Digital Future",
      subtitle: "A quick tour inside Madinaty's tech world and how we turn challenges into smart solutions.",
      play: "Play Video",
    },
    services: {
      tag: "Services",
      title: "An Integrated Ecosystem",
      subtitle: "From software to artificial intelligence — everything your organization needs under one roof.",
      items: [
        { t: "Hotel Management Systems", d: "A complete solution for reservations, rooms, reception, accounting and restaurants." },
        { t: "ERP Business Systems", d: "Manage sales, purchasing, inventory, HR, accounting and reporting." },
        { t: "SCADA Systems", d: "Monitoring & control solutions for factories, water, sewage and energy." },
        { t: "Security Cameras & Systems", d: "Surveillance cameras, biometrics, access control and alarm systems." },
        { t: "Website Design", d: "Fast professional websites, responsive on all devices with SEO optimization." },
        { t: "Mobile Apps", d: "Android & iOS app development with modern interfaces and high performance." },
        { t: "AI Solutions", d: "Virtual assistants, chatbots, data analysis and process automation." },
        { t: "Hosting & Servers", d: "Cloud hosting, dedicated servers, backups, protection and security." },
      ],
    },
    why: {
      tag: "Why Madinaty?",
      title: "Reasons to make us your first choice",
      items: ["Specialized team", "Integrated solutions", "Latest technologies", "Continuous support", "Competitive pricing", "High quality", "Professional execution", "User training"],
    },
    sectors: { tag: "Sectors", title: "Sectors We Serve", items: ["Hotels & Resorts", "Commercial Companies", "Factories", "Hospitals", "Universities", "Schools", "Municipalities", "Ministries", "Transport Companies", "Oil & Energy"] },
    work: {
      tag: "Our Methodology",
      title: "How We Work",
      items: [
        { t: "Needs Analysis", d: "We deeply understand your goals and challenges first." },
        { t: "Technical Study", d: "We design a precise and clear technical plan." },
        { t: "Solution Design", d: "Modern architecture with contemporary interfaces." },
        { t: "Implementation", d: "Professional development and installation to the highest standards." },
        { t: "Testing & Launch", d: "Comprehensive testing to ensure quality and stability." },
        { t: "Training", d: "Training your teams to use the systems efficiently." },
        { t: "Support & Maintenance", d: "Continuous support and periodic maintenance around the clock." },
      ],
    },
    projects: {
      tag: "Our Work",
      title: "Our Projects",
      items: ["Hotel Systems", "ERP Systems", "SCADA Systems", "Websites", "Mobile Apps", "AI Solutions", "Security Systems"],
      viewProject: "View Project",
      details: [
        { overview: "A complete platform to manage reservations, rooms, front-desk, restaurants and accounting in one place with real-time reporting and a premium guest experience.", features: ["Reservations & room management", "Centralized front-desk & billing", "Restaurant & venue management", "Real-time financial reports", "Multi-branch dashboard", "OTA & payment gateway integration"] },
        { overview: "Comprehensive ERP unifying sales, purchasing, inventory, HR and accounting with a single management view across all branches.", features: ["Sales & purchasing management", "Real-time inventory", "HR & payroll", "Full financial accounting", "Executive KPIs & reports", "Multi-branch sync"] },
        { overview: "SCADA solutions for industrial monitoring & control of factories, water and energy plants with instant alerts and reliable automation.", features: ["Real-time HMI monitoring", "Smart fault alerts", "Industrial process automation", "PLC & IoT sensor integration", "Data archiving & analysis", "Centralized control panels"] },
        { overview: "Professional, high-performance and SEO-friendly websites — responsive across all devices — engineered to convert visitors into customers.", features: ["Modern responsive design", "Ultra-fast performance", "SEO optimization", "CMS content management", "Google Analytics integration", "Advanced security"] },
        { overview: "Android & iOS apps with modern interfaces and high performance, smooth UX and full integration with your existing systems.", features: ["Android & iOS apps", "Modern UI/UX", "Ultra-fast load times", "Push notifications", "API & ERP integration", "App Store & Google Play publishing"] },
        { overview: "Custom AI solutions including virtual assistants, chatbots, process automation and data analytics tailored to your business.", features: ["Smart chatbots", "Virtual assistants", "Predictive analytics", "RPA process automation", "Natural language processing", "WhatsApp & web integration"] },
        { overview: "Integrated security including surveillance cameras, biometrics, access control and alarm systems to protect your facility.", features: ["HD surveillance cameras", "Biometric access control", "Advanced alarm systems", "Remote monitoring", "Centralized recording", "24/7 technical support"] },
      ],
    },
    partners: { tag: "Partners", title: "Partners in Success", body: "We are proud of the trust of our clients and partners for whom we delivered integrated technology solutions." },
    contact: {
      tag: "Contact",
      title: "Let's Start Your Next Project",
      subtitle: "Tell us about your project and our team will reach out to prepare a suitable technical quote.",
      fields: { name: "Full Name", email: "Email", phone: "Phone Number", company: "Company / Entity", service: "Required Service", message: "Project Details" },
      selectService: "Select a service",
      submit: "Send Request",
      sending: "Sending...",
      success: "Your request was received! We'll contact you soon.",
      error: "Something went wrong, please try again.",
      info: { phone: "Phone", email: "Email", location: "Location", locationVal: "Baghdad - Karrada" },
    },
    achievements: { tag: "Our Impact", title: "Numbers That Speak For Us" },
    timeline: { tag: "Our Journey", title: "Milestones Timeline", subtitle: "From founding to today — the Madenati story." },
    map: {
      tag: "Our Location",
      title: "Visit Us at Our Offices",
      subtitle: "You're welcome to drop by and discuss your next project face-to-face with our technical team.",
      cardTitle: "Office Information",
      addressLabel: "Address",
      hoursLabel: "Working Hours",
      directions: "Get Directions",
      openMaps: "Open in Google Maps",
      defaultAddress: "Iraq - Baghdad - Karrada - Al-Aradat Al-Hindiya, near Development Bank",
      defaultHours: "Sat – Thu: 8:00 AM – 5:00 PM | Friday: Closed",
    },
    testimonials: { tag: "Testimonials", title: "What Our Clients Say", subtitle: "Our clients' trust is our greatest achievement." },
    faq: { tag: "FAQ", title: "Answers to Your Most Common Questions", subtitle: "Everything you want to know about our services and how we work." },
    whatsapp: "Chat on WhatsApp",
    careers: { tag: "Careers", title: "Join the Madinaty Team", subtitle: "We're always looking for exceptional talent to build the digital future.", type: "Type", location: "Location", requirements: "Requirements", apply: "Apply via WhatsApp", empty: "No open positions at the moment." },
    newsletter: { title: "Subscribe to Our Newsletter", subtitle: "Latest tech news and offers in your inbox.", placeholder: "Your email", button: "Subscribe", success: "Subscribed successfully!", error: "Subscription failed." },
    cookie: { text: "We use cookies to improve your experience on our site.", accept: "Accept", more: "Learn more" },
    chatHuman: "Talk to a human",
    profile: "Company Profile",
    serviceDetail: { overview: "Overview", cta: "Request This Service", back: "All Services", features: "Key Features" },
    projectDetail: { back: "All Projects", overview: "Overview", features: "Key Features", watchIntro: "Watch Intro Video", cta: "Request This System", videoUnavailable: "Video not available yet", screenshots: "Screenshots", screenshotsTitle: "Inside the system" },
    share: { title: "Share", copy: "Copy link", copied: "Copied ✓" },
    filters: { all: "All", searchBlog: "Search articles...", searchCases: "Search case studies...", noResults: "No results match your search." },
    quote: {
      tag: "Instant Quote",
      title: "Calculate your project cost in seconds",
      subtitle: "Pick a system type, team size, and modules — get an estimated price range and delivery time instantly.",
      types: { hotel: "Hotel Systems", erp: "ERP Systems", scada: "SCADA", website: "Website", mobile: "Mobile App", ai: "AI Solutions", security: "Security" },
      chooseType: "Choose system type",
      users: "Users",
      modules: "Modules",
      estimate: "Estimated Price",
      type: "Type",
      delivery: "Delivery",
      weeks: "weeks",
      usd: "USD — estimated range",
      disclaimer: "* This is a rough estimate. Final pricing depends on actual requirements — we'll follow up with a detailed quote within 24 hours.",
      getPersonalized: "Get an instant personalized quote",
      sendCta: "Send request",
      sending: "Sending...",
      sentBadge: "Sent ✓",
      success: "Received! We'll get back to you within 24 hours.",
      error: "Failed to send, try again",
      errPhone: "Enter a valid phone number",
      rateLimited: "Too many requests. Try later.",
      anonName: "Visitor (Quote Calculator)",
      leadTemplate: "Quote calculator request:\n\n- System type: {type}\n- Users: {users}\n- Modules: {modules}\n- Estimate: ${low} – ${high}\n- Delivery: {w1}–{w2} weeks",
    },
    booking: {
      tag: "Book a Call",
      title: "Book your free consultation",
      subtitle: "30-minute call with a technical consultant — no commitment.",
      pickDate: "Pick a date",
      pickTime: "Pick a time slot",
      closedDay: "This day is closed (Friday off).",
      topicPh: "Consultation topic (optional)",
      notesPh: "Anything else we should know before the call? (optional)",
      submit: "Confirm booking",
      sending: "Booking...",
      success: "Booked! Confirmation email sent.",
      errPickSlot: "Pick a date and time first",
      errFields: "Enter a name and a valid phone (min 7 digits)",
      errTaken: "This slot is already booked, pick another",
      errRate: "Too many requests. Try again later.",
      errGeneric: "Booking failed, try again",
      confirmedTitle: "Your booking is confirmed",
      confirmedSub: "We'll call you at the scheduled time on the number you provided.",
    },
    sectorExplorer: {
      tag: "Explore by Sector",
      title: "Best solutions for your industry",
      subtitle: "Pick your sector to see the most relevant systems and case studies.",
      relatedCases: "Related case studies",
      viewAll: "View all cases",
    },
    support: {
      tag: "Support",
      title: "Open a support ticket",
      subtitle: "For existing customers — we'll get back to you during business hours.",
      subjectPh: "Ticket subject",
      messagePh: "Describe your issue in detail...",
      submit: "Send ticket",
      sending: "Sending...",
      success: "Ticket opened, we'll be in touch",
      sentTitle: "Your ticket is received ✅",
      sentSub: "Our support team will reply during business hours.",
      errFields: "Please fill all required fields",
      errRate: "Too many requests. Try again later.",
      errGeneric: "Failed to send, try again",
      priorities: { low: "Low", normal: "Normal", high: "High", urgent: "Urgent" },
    },
    stickyBar: {
      title: "We'll call you back within 10 minutes",
      subtitle: "Just leave your number",
      placeholder: "07XX XXXXXXX",
      cta: "Call me",
      success: "Done! We'll call you soon ✓",
      error: "Could not send, try again",
      rateLimited: "Too many requests. Try again later.",
      invalid: "Enter a valid phone number",
      leadName: "Callback request (sticky bar)",
      leadMessage: "Please call me back as soon as possible.",
    },
    legal: { privacy: "Privacy Policy", terms: "Terms of Use", backHome: "Back to Home", updated: "Last updated" },
    footer: { slogan: "Madinaty... Smart solutions for a better future", rights: "All rights reserved", built: "Madinaty for Information Technology and Smart Solutions" },
    team: { tag: "Our Team", title: "The Leadership Behind Madinaty", subtitle: "A team of experts driving your digital transformation journey." },
    blog: { tag: "Blog", title: "Latest Articles & News", subtitle: "Tech insights and articles from the Madinaty team.", readMore: "Read More", back: "Back to Blog", empty: "No articles yet.", by: "By" },
    cases: { tag: "Case Studies", title: "Our Clients' Success Stories", subtitle: "Problem, solution and result — this is how we create impact.", problem: "The Challenge", solution: "The Solution", result: "The Result", back: "Back to Case Studies", empty: "No case studies yet.", client: "Client", sector: "Sector", viewCase: "View Case Study" },
    chat: { title: "AI Assistant", welcome: "Hello! I'm Madinaty's AI assistant. How can I help you today?", placeholder: "Type your question...", open: "Chat with us", handoffPreface: "Hi Madenati team, I was chatting with the AI assistant and would like to speak with someone about:" },
  },
};

export const CONTACT_INFO = {
  phone: "07826699000",
  whatsapp: "9647826699000",
  email: "madenati@dlr.iq",
  website: "www.madenati.dlr.iq",
  address: "العراق - بغداد - الكرادة - العرضات الهندية قرب مصرف التنمية",
  addressEn: "Iraq - Baghdad - Karrada - Al-Aradat Al-Hindiya, near Development Bank",
  addressKu: "عێراق - بەغدا - کەڕادە - عەرەداتی هیندی، نزیک بانکی گەشەپێدان",
  social: {
    facebook: "https://facebook.com/madenati.tech",
    instagram: "https://instagram.com/madenati.tech",
    linkedin: "https://linkedin.com/company/madenati-tech",
    tiktok: "https://tiktok.com/@madenati.tech",
  },
};
